import React from 'react';
import Slider from "react-slick";

const NextArrow = (props: any) => {
    const { onClick } = props;
    return (
        <button
            className="absolute right-[-12px] md:right-[-25px] top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-xl flex items-center justify-center z-10 hover:bg-black hover:text-white transition-all border border-gray-100 group"
            onClick={onClick}
        >
            <i className="fa-solid fa-chevron-right text-xs transition-transform group-hover:translate-x-0.5"></i>
        </button>
    );
}

const PrevArrow = (props: any) => {
    const { onClick } = props;
    return (
        <button
            className="absolute left-[-12px] md:left-[-25px] top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-xl flex items-center justify-center z-10 hover:bg-black hover:text-white transition-all border border-gray-100 group"
            onClick={onClick}
        >
            <i className="fa-solid fa-chevron-left text-xs transition-transform group-hover:-translate-x-0.5"></i>
        </button>
    );
}

interface BuilderOffersSectionProps {
    project: any;
    onClaimOffer: (offer: any) => void;
}

const BuilderOffersSection: React.FC<BuilderOffersSectionProps> = ({ project, onClaimOffer }) => {
    if (!project.builderOffers || project.builderOffers.length === 0) return null;

    const sliderSettings = {
        dots: true,
        infinite: project.builderOffers.length > 1,
        speed: 500,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '40px',
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    centerPadding: '20px',
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    arrows: false,
                    dots: true
                }
            }
        ]
    };

    return (
        <div id="builder-offers" className="card border border-gray-200 shadow-sm rounded-2xl mb-4 overflow-hidden scroll-mt-32">
            <div className="bg-white pt-2.5 pb-0 px-6 md:px-8 border-b border-gray-50">
                <div className="flex items-center justify-between mb-1">
                    <h4 className="text-xl md:text-2xl font-black bg-clip-text text-transparent bg-gradient-to-r from-[#05144b] to-[#4c1d95] leading-tight">Builder Offers</h4>
                    <div className="flex items-center gap-1.5 bg-[#05144b]/5 px-2 py-0.5 rounded-full">
                        <span className="w-1 h-1 bg-[#f1ae24] rounded-full animate-pulse"></span>
                        <span className="text-[10px] font-medium text-black">Live</span>
                    </div>
                </div>
                <div className="w-8 h-0.5 bg-[#f1ae24] rounded-full mb-2"></div>
            </div>

            <style>
                {`
                #builder-offers .slick-slide > div { margin: 0 10px; }
                #builder-offers .slick-list { margin: 0; padding: 10px 0 !important; }
                #builder-offers .slick-dots { bottom: -8px; }
                #builder-offers .slick-dots li { margin: 0 1px; }
                #builder-offers .slick-dots li button:before { color: #05144b; font-size: 5px; }
                #builder-offers .slick-dots li.slick-active button:before { color: #f1ae24; font-size: 7px; }

                .voucher-card {
                    position: relative;
                    background: white;
                    border: 2px solid #f1ae24;
                    border-radius: 24px;
                    overflow: visible;
                }

                .voucher-inner-bg {
                    position: absolute;
                    inset: 6px;
                    border: 1.5px dashed #05144b;
                    border-radius: 20px;
                    pointer-events: none;
                }

                .notch {
                    position: absolute;
                    top: 50%;
                    width: 24px;
                    height: 24px;
                    background: #f9fafb; /* Color of the page background */
                    border-radius: 50%;
                    transform: translateY(-50%);
                    z-index: 20;
                    border: 2px solid #f1ae24;
                }
                .notch-left { left: -14px; border-left-color: transparent; }
                .notch-right { right: -14px; border-right-color: transparent; }

                .ribbon-wrapper {
                    position: relative;
                    margin-top: 10px;
                    margin-bottom: 24px;
                    display: inline-block;
                }

                .ribbon-main {
                    position: relative;
                    background: #f1ae24;
                    color: #05144b;
                    font-weight: 900;
                    font-size: 13px;
                    text-transform: none;
                    padding: 6px 22px;
                    letter-spacing: normal;
                    z-index: 5;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                }

                .ribbon-tail {
                    position: absolute;
                    top: 4px;
                    width: 30px;
                    height: 100%;
                    background: #f1ae24;
                    z-index: 1;
                }

                .ribbon-tail-l {
                    left: -15px;
                    clip-path: polygon(0 0, 15px 0, 15px 100%, 0 100%, 10px 50%);
                }

                .ribbon-tail-r {
                    right: -15px;
                    clip-path: polygon(0 0, 100% 0, 20px 50%, 100% 100%, 0 100%);
                }

                .ribbon-fold {
                    position: absolute;
                    bottom: -4px;
                    border: 2px solid transparent;
                    z-index: 2;
                }

                .ribbon-fold-l {
                    left: 0;
                    border-top-color: #f1ae24; /* Adjusted to match main amber */
                    border-right-color: #f1ae24;
                }

                .ribbon-fold-r {
                    right: 0;
                    border-top-color: #f1ae24;
                    border-left-color: #f1ae24;
                }
                `}
            </style>
            
            <div className="p-2 md:py-4 md:px-6 bg-gray-50/20">
                <Slider {...sliderSettings}>
                    {project.builderOffers.map((offer: any, idx: number) => {
                    const isExpired = offer.tillDate && new Date(offer.tillDate) < new Date();
                    if (isExpired) return null;
                    
                    return (
                        <div key={idx} className="relative py-2">
                            <div className="voucher-card flex flex-col md:flex-row overflow-hidden min-h-[140px]">
                                {/* Dashed Inner Border */}
                                <div className="voucher-inner-bg"></div>

                                {/* Notches */}
                                <div className="notch notch-left"></div>
                                <div className="notch notch-right"></div>

                                {/* 1. Left Stub (Navy) */}
                                <div className="w-full md:w-[20%] p-4 flex flex-col items-center justify-center relative border-r-2 border-dashed border-white/30" style={{ background: 'linear-gradient(135deg, #05144b 0%, #4c1d95 100%)' }}>
                                    <div className="relative">
                                        {/* Sparkles */}
                                        <i className="fa-solid fa-sparkles absolute -top-4 -left-4 text-amber-300 text-[10px] animate-pulse"></i>
                                        <i className="fa-solid fa-sparkles absolute -top-6 right-0 text-amber-300 text-[8px] animate-pulse"></i>
                                        <i className="fa-solid fa-star absolute bottom-0 -left-6 text-amber-300 text-[8px]"></i>
                                        <i className="fa-solid fa-star absolute -bottom-4 right-2 text-amber-300 text-[10px]"></i>
                                        
                                        {/* Gift Icon */}
                                        <div className="w-16 h-16 bg-[#f1ae24] rounded-xl flex items-center justify-center text-[#05144b] shadow-xl relative overflow-visible">
                                            <i className="fa-solid fa-gift text-3xl"></i>
                                            {/* Bow detail */}
                                            <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-6 h-4 border-2 border-[#05144b] rounded-full"></div>
                                        </div>
                                    </div>
                                </div>

                                {/* 2. Right Content Area */}
                                <div className="flex-1 bg-white p-3 md:p-4 flex flex-col md:flex-row gap-4 relative z-10">
                                    
                                    {/* Middle Section: Offer Text */}
                                    <div className="flex-1 flex flex-col items-center md:items-start justify-center">
                                        <div className="ribbon-wrapper">
                                            <div className="ribbon-tail ribbon-tail-l"></div>
                                            <div className="ribbon-main">Exclusive Offer</div>
                                            <div className="ribbon-tail ribbon-tail-r"></div>
                                            <div className="ribbon-fold ribbon-fold-l"></div>
                                            <div className="ribbon-fold ribbon-fold-r"></div>
                                        </div>
                                        
                                        <div className="flex flex-col items-center md:items-start">
                                            <span className="text-xl font-medium text-black leading-none">Flat</span>
                                            <div className="flex items-baseline gap-2">
                                                <h3 className="text-6xl md:text-7xl font-bold text-black tracking-tight">
                                                    {offer.priceImpact || '25%'}
                                                </h3>
                                                <span className="text-4xl font-bold text-black">OFF</span>
                                            </div>
                                            <p className="text-lg font-bold text-black mt-1 text-center md:text-left">
                                                {offer.example || 'ON ALL SERVICES'}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Right Section: Code, Validity and Button */}
                                    <div className="w-full md:w-[55%] flex flex-col justify-center gap-4 pl-0 md:pl-2 md:border-l-2 border-dashed border-gray-200">
                                        <div className="space-y-3">
                                            <div className="flex flex-col gap-1">
                                                <span className="text-[13px] font-bold text-black opacity-60">Use Code:</span>
                                                <div className="bg-[#05144b] rounded-xl p-2 border-2 border-dashed border-[#f1ae24] flex items-center justify-center">
                                                    <span className="text-[#f1ae24] text-xl font-black">
                                                        {offer.offerType || 'SAVE25'}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="flex items-center gap-3">
                                                <div className="w-12 h-12 rounded-lg bg-gray-50 flex items-center justify-center border border-gray-100 shadow-sm">
                                                    <i className="fa-solid fa-calendar-alt text-[#05144b] text-lg"></i>
                                                </div>
                                                <div className="flex flex-col">
                                                    <span className="text-[12px] font-bold text-black leading-none">Validity:</span>
                                                    <span className="text-[15px] font-bold text-black mt-1">
                                                        {offer.startDate ? new Date(offer.startDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' }) : '14 APR'} 
                                                        {" - "}
                                                        {offer.tillDate ? new Date(offer.tillDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' }) : '01 MAY'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <button 
                                            onClick={() => onClaimOffer(offer)}
                                            className="w-full py-3 rounded-full bg-gradient-to-r from-[#05144b] to-[#4c1d95] text-white text-[13px] md:text-[14px] font-black transition-all shadow-lg active:scale-95 flex items-center justify-center gap-2 group"
                                        >
                                            <span className="whitespace-nowrap">Claim Offer Now</span>
                                            <i className="fa-solid fa-arrow-right text-[10px] transition-transform group-hover:translate-x-1 flex-shrink-0"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
                </Slider>
            </div>

            {/* Premium Validity Disclaimer */}
            <div className="bg-white border-t border-gray-100 p-2 md:p-3 flex items-center justify-center">
                <div className="flex items-center gap-2 max-w-2xl text-center">
                    <div className="w-6 h-6 rounded-md bg-gray-100 flex items-center justify-center flex-shrink-0">
                        <i className="fa-solid fa-shield-check text-[#05144b] text-[10px]"></i>
                    </div>
                    <p className="text-[10px] md:text-[11px] font-medium text-black leading-relaxed mb-0">
                        All schemes validated by relationship managers. Subject to inventory nodes.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BuilderOffersSection;

